import { render, staticRenderFns } from "./custom-overlay.vue?vue&type=template&id=35ff02aa&scoped=true&"
import script from "./custom-overlay.vue?vue&type=script&lang=js&"
export * from "./custom-overlay.vue?vue&type=script&lang=js&"
import style0 from "./custom-overlay.vue?vue&type=style&index=0&id=35ff02aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ff02aa",
  null
  
)

export default component.exports